import React from 'react';
import { Select } from './Select';
import { PageSize } from '../utils/enums';

export const PaginationSelect = ({ size = 10, onPageSizeChanged = Function.prototype, id = 'select_option', ...props }) => (
	<Select
		id={id}
		options={[
			{ value: 10, text: '10' },
			{ value: 20, text: '20' },
			{ value: 50, text: '50' },
			{ value: PageSize.All, text: 'Wszystkie' }
		]}
		value={parseInt(size)}
		onSelect={(option) => onPageSizeChanged(option)}
	/>
);
